//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  nuxtI18n: {
    paths: {
      br: '/busca',
      en: '/search',
      es: '/buscar'
    }
  },

  head() {
    return this.$helpers.seoBuilder(this, {
      staticTitle: this.$t('breadcrumb')
    })
  },

  computed: {
    breadcrumbs() {
      const breadcrumbs = [
        {
          name: this.$t('home'),
          path: '/'
        },
        {
          name: this.$t('breadcrumb'),
          path: '/busca'
        }
      ]

      return breadcrumbs
    }
  },

  watch: {
    '$route.query': {
      handler() {
        this.searchByQuery()
      },
      deep: true
    }
  },

  mounted() {
    this.initGoogleCSE()
  },

  methods: {
    initGoogleCSE() {
      const head = document.getElementsByTagName('head')[0]
      const script = document.createElement('script')

      const self = this

      script.type = 'text/javascript'
      script.src = 'https://cse.google.com/cse.js?cx=2fd31f5c4d9d6b0e8'
      script.onload = function () {
        setTimeout(() => {
          self.searchByQuery()
        }, 1000)
      }

      head.appendChild(script)
    },

    searchByQuery() {
      const element =
        window.google.search.cse.element.getElement('searchresults')
      const searchGoogleDiv = document.querySelector('.gsc-expansionArea')
      const { q } = this.$route.query

      if (element) {
        element.execute(q)
      }

      // Insert search title and query inside Google container
      searchGoogleDiv.insertAdjacentHTML(
        'afterbegin',
        `<div class="search-container"><h1><b>${
          this.$route.query.q
            ? `${this.$t('search')}:</b> <span>${this.$route.query.q}</span>`
            : ''
        }</h1></div>`
      )
    }
  }
}
